import React, { useState } from 'react';
import styled from 'styled-components';
import useDesignUtils from '../../../hooks/useDesignUtils';
import Benefits1 from '../../../assets/images/benefits/benefits1.png';
import Benefits1Mx from '../../../assets/images/benefits/benefits1mx.png';
import Benefits2 from '../../../assets/images/benefits/benefits2.png';
import Benefits2Mx from '../../../assets/images/benefits/benefits2mx.png';
import Benefits3 from '../../../assets/images/benefits/benefits3.png';
import Benefits3Mx from '../../../assets/images/benefits/benefits3mx.png';
import Benefits4 from '../../../assets/images/benefits/benefits4.png';
import Benefits4Mx from '../../../assets/images/benefits/benefits4mx.png';
import BenefitsDesc1 from '../../../assets/images/benefits/benefits_desc1.png';
import BenefitsDesc1Mx from '../../../assets/images/benefits/benefits_desc1mx.png';
import BenefitsDesc2 from '../../../assets/images/benefits/benefits_desc2.png';
import BenefitsDesc2Mx from '../../../assets/images/benefits/benefits_desc2mx.png';
import BenefitsDesc3 from '../../../assets/images/benefits/benefits_desc3.png';
import BenefitsDesc3Mx from '../../../assets/images/benefits/benefits_desc3mx.png';
import BenefitsDesc4 from '../../../assets/images/benefits/benefits_desc4.png';
import BenefitsDesc4Mx from '../../../assets/images/benefits/benefits_desc4mx.png';
import { Box, Copy, HStack, VStack } from '../../SimpleUI';
import SectionLayout from '../SectionLayout';
import { useCountry } from '../../../contexts/CountryContext';

const OptionCard = styled(Box)`
  background: ${(props) => (props.isSelected ? 'white' : '#c2faed')};
  width: 100%;
  max-width: 500px;
  border-radius: 15px;
  margin: 20px auto;
  padding: 10px 20px;
  position: relative;
  z-index: 2;
  cursor: pointer;
  color: #454545;
  transform: ${(props) => (props.isSelected ? 'scale(1)' : 'scale(0.9)')};
  transition: all 0.15s ease-out;
  &:before {
    content: '';
    z-index: 1;
    padding: 20px;
    width: 100%;
    height: 100%;
    display: inline-block;
    position: absolute;
    border: 1.5px solid ${(props) => (props.isSelected ? 'white' : '#c2faed')};
    top: 5px;
    left: -5px;
    border-radius: 15px;
  }
  @media (max-width: 768px) {
    max-width: 80px;
  }
`;

const Benefits = () => {
  const [selected, setSelected] = useState(0);
  const { isMobile } = useDesignUtils();
  const { countryPrefix } = useCountry();

  const isAr = countryPrefix === '/ar';

  const StackDirection = isMobile ? VStack : HStack;
  const Options = [
    {
      id: 0,
      order: '01',
      title: 'Ahorrar es ',
      titleBold: 'fácil y rápido',
      text: isAr
        ? 'El monto mínimo es de 10 dólares o su equivalente en pesos.'
        : 'El monto mínimo es 100 MXN.',
      image: isAr ? Benefits1 : Benefits1Mx,
      desc: isAr ? BenefitsDesc1 : BenefitsDesc1Mx,
    },
    {
      id: 1,
      order: '02',
      title: 'Ganancias ',
      titleBold: 'mensuales',
      text: isAr
        ? 'Con una tasa del 8% anual en dólares.'
        : 'Con una tasa del 10% anual.',
      image: isAr ? Benefits2 : Benefits2Mx,
      desc: isAr ? BenefitsDesc2 : BenefitsDesc2Mx,
    },
    {
      id: 2,
      order: '03',
      title: 'Tu dinero ',
      titleBold: 'disponible',
      text: isAr
        ? 'Podés retirar tus ganancias mensualmente, y tu capital a los 180 días de realizada tu inversión.'
        : 'Puedes retirar tus ganancias mensualmente, y tu capital a los 90 días de realizada tu inversión.',
      image: isAr ? Benefits3 : Benefits3Mx,
      desc: isAr ? BenefitsDesc3 : BenefitsDesc3Mx,
    },
    {
      id: 3,
      order: '04',
      title: isAr ? 'Ahorrá ' : 'Ahorra ',
      titleBold: 'todos los meses',
      text: isAr
        ? 'Conocé los beneficios de ahorrar en el tiempo'
        : 'Conoce los beneficios de ahorrar en el tiempo',
      image: isAr ? Benefits4 : Benefits4Mx,
      desc: isAr ? BenefitsDesc4 : BenefitsDesc4Mx,
    },
  ];

  return (
    <SectionLayout paddingY="large" backgroundColor="primary">
      <Box
        width="100%"
        maxWidth="1200px"
        paddingX="medium"
        margin="auto"
        height="100%"
        maxHeight={{ mobile: '600px', desktop: '750px' }}
      >
        <Box marginY={{ mobile: 'none', desktop: 'xlarge' }}>
          <Copy
            fontSize="bigHeader"
            tag="h2"
            fontWeight="bold"
            textAlign="center"
          >
            {isAr
              ? 'Beneficios de ahorrar en Simplestate'
              : 'Descubre los increíbles beneficios de ahorrar en Simplestate'}
          </Copy>
        </Box>
        <Box
          display="flex"
          flexDirection={{ mobile: 'column', desktop: 'row' }}
          justifyContent="space-around"
          alignItems="flex-start"
        >
          {isMobile && (
            <>
              <Box display="flex" flexDirection="row" width="90%" margin="auto">
                {Options.map((option) => (
                  <OptionCard
                    key={option.id}
                    isSelected={selected === option.id}
                    onClick={() => setSelected(option.id)}
                  >
                    <HStack alignItems="flex-end" space="medium">
                      <Copy
                        fontWeight="bold"
                        color="primary"
                        fontSize="_newTitle"
                      >
                        {option.order}
                      </Copy>
                    </HStack>
                  </OptionCard>
                ))}
              </Box>
              <Box
                marginY="medium"
                paddingBottom="large"
                margin="auto"
                maxWidth="400px"
              >
                <VStack space="small" minHeight="70px">
                  <Copy fontSize="_newTitle">
                    {Options[selected].title}
                    <Copy tag="span" fontWeight="semibold" fontSize="_newTitle">
                      {Options[selected].titleBold}
                    </Copy>
                  </Copy>
                  <Copy fontSize="_small">{Options[selected].text}</Copy>
                </VStack>
              </Box>
            </>
          )}
          <Box
            width={{ mobile: '100%', desktop: '50%' }}
            maxWidth={{ mobile: '200px', desktop: '100%' }}
            textAlign="center"
            margin={{ mobile: 'auto', desktop: 'none' }}
            position="relative"
          >
            <Box
              tag="img"
              position="absolute"
              src={Options[selected].desc}
              top={{ mobile: 'auto', desktop: '10%' }}
              left={{ mobile: 'auto', desktop: '-8%' }}
              bottom={{ mobile: '-30%', desktop: 'auto' }}
            />
            <Box tag="img" src={Options[selected].image} />
          </Box>

          {!isMobile && (
            <Box display="flex" flexDirection="column">
              {Options.map((option, i) => (
                <OptionCard
                  key={option.id}
                  isSelected={selected === option.id}
                  onClick={() => setSelected(option.id)}
                >
                  <HStack alignItems="flex-end" space="medium">
                    <Copy
                      fontWeight="bold"
                      color="primary"
                      fontSize="_newTitle"
                    >
                      {option.order}
                    </Copy>
                    <VStack>
                      <Copy fontSize="_newTitle">
                        {option.title}
                        <Copy
                          tag="span"
                          fontWeight="semibold"
                          fontSize="_newTitle"
                        >
                          {option.titleBold}
                        </Copy>
                      </Copy>
                      <Copy fontSize="_small">{option.text}</Copy>
                    </VStack>
                  </HStack>
                </OptionCard>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </SectionLayout>
  );
};

export { Benefits };
